// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$OrcaPaymentPage from "./Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./Utilities/LoggerUtils.bs.js";
import * as PaymentError$OrcaPaymentPage from "./Types/PaymentError.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";

function ThreeDSAuth(props) {
  let match = React.useState(() => false);
  let match$1 = React.useState(() => true);
  let setloader = match$1[1];
  let threeDsAuthoriseUrl = React.useRef("");
  let match$2 = React.useState(() => 600000.0);
  let setExpiryTime = match$2[1];
  let expiryTime = match$2[0];
  let logger = HyperLogger$OrcaPaymentPage.make(undefined, {
    TAG: "Elements",
    _0: "Payment"
  }, undefined, undefined, undefined);
  let handleFrictionLess = () => {
    let ele = document.querySelector("#threeDsAuthDiv");
    if (ele == null) {
      return;
    }
    let form1 = Utils$OrcaPaymentPage.makeForm(ele, threeDsAuthoriseUrl.current, "3dsFrictionLess");
    form1.submit();
  };
  let eventsToSendToParent = [
    "confirmParams",
    "poll_status",
    "openurl_if_required"
  ];
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
        return;
      }
      let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
      let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
      let paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
      let publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
      let sdkAuthorization = Utils$OrcaPaymentPage.getOptionString(metaDataDict, "sdkAuthorization");
      logger.setClientSecret(paymentIntentId);
      logger.setSdkAuthorization(Core__Option.getOr(sdkAuthorization, ""));
      logger.setMerchantId(publishableKey);
      let headersDict = Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "headers")), {});
      threeDsAuthoriseUrl.current = Utils$OrcaPaymentPage.getString(Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "threeDSData")), {}), "three_ds_authorize_url", "");
      let headers = Utils$OrcaPaymentPage.convertDictToArrayOfKeyStringTuples(headersDict);
      let threeDsMethodComp = Utils$OrcaPaymentPage.getString(metaDataDict, "3dsMethodComp", "U");
      Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.threeDsAuth(paymentIntentId, logger, threeDsMethodComp, Object.fromEntries(headers), Primitive_option.some(sdkAuthorization)).then(json => {
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (Core__Option.isSome(dict["error"])) {
          let errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
              "fullscreen",
              false
            ]]);
          Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
          return Promise.resolve(null);
        }
        let creq = Utils$OrcaPaymentPage.getString(dict, "challenge_request", "");
        let challengeRequestKey = Utils$OrcaPaymentPage.getString(dict, "challenge_request_key", "creq");
        let transStatus = Utils$OrcaPaymentPage.getString(dict, "trans_status", "Y");
        let acsUrl = Utils$OrcaPaymentPage.getString(dict, "acs_url", "");
        let ele = document.querySelector("#threeDsAuthDiv");
        LoggerUtils$OrcaPaymentPage.handleLogging(logger, transStatus, "DISPLAY_THREE_DS_SDK", "CARD", undefined);
        if (!(ele == null)) {
          if (transStatus === "C") {
            setloader(param => false);
            let form = Utils$OrcaPaymentPage.makeForm(ele, acsUrl, "3dsChallenge");
            let input = document.createElement("input");
            input.name = challengeRequestKey;
            input.value = creq;
            form.target = "threeDsAuthFrame";
            form.appendChild(input);
            form.submit();
          } else {
            handleFrictionLess();
          }
        }
        return Promise.resolve(json);
      }), err => {
        let exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
        LoggerUtils$OrcaPaymentPage.handleLogging(logger, JSON.stringify(exceptionMessage), "DISPLAY_THREE_DS_SDK", "CARD", "ERROR");
        let errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
        Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
        return Promise.resolve(null);
      });
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  React.useEffect(() => {
    if (expiryTime < 1000.0) {
      handleFrictionLess();
    }
    let intervalID = setInterval(() => setExpiryTime(prev => prev - 1000.0), 1000);
    return () => {
      clearInterval(intervalID);
    };
  }, [expiryTime]);
  return JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          className: "hidden",
          id: "threeDsAuthDiv"
        }),
        JsxRuntime.jsx("iframe", {
          id: "threeDsAuthFrame",
          style: {
            minHeight: "500px",
            outline: "none"
          },
          title: "3D Secure Authentication Frame",
          name: "threeDsAuthFrame",
          width: "100%"
        })
      ],
      className: "backdrop-blur-xl"
    }),
    closeCallback: handleFrictionLess,
    loader: match$1[0],
    setOpenModal: match[1],
    openModal: match[0]
  });
}

let make = ThreeDSAuth;

export {
  make,
}
/* react Not a pure module */
